'use client'

import { usePathname } from 'next/navigation'

import { CartDrawer } from '@src/components/CartDrawer/CartDrawer'
import { TopNavAccountPanel } from '@src/components/TopNavV4/TopNavAccountPanel/TopNavAccountPanel'
import { TopNavProvider } from '@src/components/TopNavV4/TopNavContext'

import { defaultTopNavProps } from './TopNav.defaults'
import { TopNavDesktop } from './TopNavDesktop/TopNavDesktop'
import { TopNavMobile } from './TopNavMobile/TopNavMobile'
import { type TopNavProps } from './TopNavProps'

export const TopNavV4 = (props: TopNavProps = defaultTopNavProps) => {
  const pathname = usePathname()
  const isCartPage = pathname?.includes('/cart')
  return (
    <TopNavProvider topNavProps={props}>
      <TopNavMobile />
      <TopNavDesktop />
      <TopNavAccountPanel />
      {!isCartPage ? <CartDrawer /> : null}
    </TopNavProvider>
  )
}
